import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/utils/Modal'
import moment from 'moment'
import { browserHistory } from 'react-router'
import useScrollShadow from 'utils/hooks/useScrollShadow'

const ViewModal = ({
  closeModal,
  translate,
  param,
  currentFilters
}) => {
  if (!param) return null

  const {
    branches = [],
    branchNamesGrouped = [],
    dtStart,
    dtEnd,
    nameList,
    themeName,
    productCount = 0,
    statusList
  } = param || {}

  const renderBranchNames = () => {
    if (branchNamesGrouped?.length >= 5) {
      return translate('price.banner.all');
    }

    const regionNames = branchNamesGrouped || [];

    const individualBranches = (branches || [])
      .filter(b => !regionNames.includes(b.dsRegion))
      .map(({ idBranch, dsBranch }) => {
        const branchCode = idBranch.replace(/^00/, '');
        const cleanedName = dsBranch
          .replace(/loja\s*/i, '')
          .trim()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(' ');
        return `${branchCode} - ${cleanedName}`;
      })
      .filter((value, index, self) => self.indexOf(value) === index);

    const allItems = [...regionNames, ...individualBranches];

    if (allItems.length > 0) {
      return allItems.join('\n');
    }

    return '-';
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return moment(date).format('DD/MM/YYYY');
  };

  const headerRef = useRef(null)
  const footerRef = useRef(null)
  const containerRef = useRef(null)
  const storesScrollRef = useScrollShadow([branches, branchNamesGrouped])

  useEffect(() => {
    const container = containerRef.current;
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;
      const atTop = scrollTop === 0;
      const atBottom = scrollTop + clientHeight >= scrollHeight - 1;
      if (headerRef.current) {
        headerRef.current.classList.toggle('scrolled', !atTop);
      }
      if (footerRef.current) {
        footerRef.current.classList.toggle('scrolled', !atBottom);
      }
    };
    if (container) {
      container.addEventListener('scroll', handleScroll);
      handleScroll();
    }
    return () => {
      container?.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <Modal
        closeModal={closeModal}
        className={'pricebanner-view-modal'}
      >
        <div ref={headerRef} className='view-modal-header'>
          <h3>
            <strong style={{ color: 'black' }}>{translate('price.banner.themelistview')}</strong>
          </h3>
        </div>

        <div ref={containerRef} className='view-container'>
          <div className="content-wrapper">
            <div className="row-pricebanner-modal">
              <div className='column-pricebanner-modal'>
                <p className='item'>{translate('price.banner.listname')}</p>
                <p className='sub-item'>{nameList || '-'}</p>
              </div>

              <div className='column-pricebanner-modal'>
                <p className='item'>{translate('price.banner.theme')}</p>
                <p className='sub-item'>{themeName || '-'}</p>
              </div>
            </div>

            <div className="row-pricebanner-modal" style={{ marginTop: '-10px', marginBottom: '-8px' }}>
              <div className="column-pricebanner-modal">
                <p className='item'>{translate('price.banner.stores')}</p>
                <div ref={storesScrollRef} className='stores-scroll-container'>
                  <p className='sub-item'>{renderBranchNames()}</p>
                </div>
              </div>

              <div className='column-pricebanner-modal'>
                <p className='item'>{translate('price.banner.period')}</p>
                <p className='sub-item'>{`${formatDate(dtStart)} - ${formatDate(dtEnd)}`}</p>
              </div>
            </div>
          </div>

          <div className="products-section">
            <div className="row-pricebanner-modal" style={{ marginBottom: '15px' }}>
              <div className='column-pricebanner-modal'>
                <p className='item' style={{ marginBottom: '2px' }}>{translate('priceBannerFront.qtUnits')} ({productCount})</p>
              </div>
              <div className='column-pricebanner-modal'>
                <p className='item'>{translate('price.banner.status')}</p>
                <p className='sub-item'>{statusList || '-'}</p>
              </div>
            </div>
          </div>
        </div>

        <div ref={footerRef} className='mission-block-new-modal-actions view-modal-footer'>
          <button
            onClick={() => {
              const listId = param?.cdPricebannerThemesList || param?.idPriceBannerList;
              const branches = param?.branches?.map(branch => branch.idBranch).join('&idBranches=');
              const dtStart = param?.dtStart;
              const dtEnd = param?.dtEnd;
              if (currentFilters) {
                try {
                  sessionStorage.setItem('priceBannerListFilters', JSON.stringify(currentFilters));
                } catch (error) {
                  // Handle error silently
                }
              }
              browserHistory.push(`/pricebanner/list-products?listId=${listId}&idBranches=${branches}&dtStart=${dtStart}&dtEnd=${dtEnd}`);
            }}
            className='mission-save'
          >
            {translate('price.banner.productlist')}
          </button>

          <button
            onClick={closeModal}
            className='mission-cancel'
          >
            {translate('close_button_label')}
          </button>
        </div>
      </Modal>
    </>
  )
}

ViewModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  param: PropTypes.object.isRequired,
  currentFilters: PropTypes.object
}

export default ViewModal
